import stylesheet from './ContainerHeader.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTContainerHeader extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get variant() {
        return this.getAttribute('variant') ?? 'horizontal';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            `container-header`,
            `variant-${this.variant}`,
        );
        container.innerHTML = `
            <div class="overline"></div>
            <div class="title"></div>
            <div class="subtitle"></div>
            <div class="header-body"></div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.overline'), 'overline');
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title');
        this.cloneSlotContentIntoContainer(container.querySelector('.subtitle'), 'subtitle');
        this.cloneSlotContentIntoContainer(container.querySelector('.header-body'), 'header-body');
        return container;
    }

}

customElements.define('nxt-container-header', NXTContainerHeader);
